import React from 'react'

import { SVGIcon } from 'components/qstrap'

const BackToTop = () => {
  const action = () => {
    if (window) {
      window.scroll({
        top: 0,
        behavior: 'smooth',
      })
    }
  }

  return (
    <div className="back-to-top swing-in-bottom-fwd">
      <span className="back-to-top__button" onClick={action}>
        <SVGIcon name="arrow_up" size="md" style={{ fill: '#fff', marginTop: '-6px' }}/>
      </span>
      <p className="back-to-top__text">Back to Top</p>
      <style jsx>
        {`
          .back-to-top {
            position: fixed;
            bottom: 80px;
            right: 1rem;
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            &__button {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              background-color: #0fc3c4;
              width: 48px;
              height: 48px;
              border-radius: 100%;
              cursor: pointer;
              margin-bottom: .5rem;
              box-shadow: 0 2px 4px 0 rgba(255, 255, 255, 0.55);
            }
            &__text {
              font-size: 12px;
              font-weight: 700;
              color: #0fc3c4;
              text-shadow: 1px 1px #fff;
            }
          }
          .swing-in-bottom-fwd {
            animation: swing-in-bottom-fwd 0.5s cubic-bezier(0.175, 0.885, 0.320, 1.275) both;
          }
          @-webkit-keyframes swing-in-bottom-fwd {
            0% {
              transform: rotateX(100deg);
              transform-origin: bottom;
              opacity: 0;
            }
            100% {
              transform: rotateX(0);
              transform-origin: bottom;
              opacity: 1;
            }
          }
          @keyframes swing-in-bottom-fwd {
            0% {
              transform: rotateX(100deg);
              transform-origin: bottom;
              opacity: 0;
            }
            100% {
              transform: rotateX(0);
              transform-origin: bottom;
              opacity: 1;
            }
          }

        `}
      </style>
    </div>
  )
}

export default BackToTop
